import useGroundContact from "../../../../hooks/useGroundContact";
import { event_status_state } from "./Svgs";
import { Event, TimelineEventTrack } from "../../../../../CommonComponents/timeline/Timeline";
import { ContactTaskSvg } from "../../../../../CommonComponents/svgs/Svgs";
import ContactOverlay from "../../../../../CommonComponents/overlays/ContactOverlay";
import useUrlNavigation from "../../../../hooks/useUrlNavigation";
import useTimeframe from "../../../../hooks/useTimeframe";
import { getContactCurrentStatus } from "../../../../utils";


const GroundContact = () => {
    const { current_time } = useTimeframe()
    const { navigate_to } = useUrlNavigation()
    const { timelineContactData, setSelectedContact, selectedContact } = useGroundContact()

    return (
        <TimelineEventTrack>
            {timelineContactData.map((event: any, index) => {
                const { startTime, endTime, groundStationName } = event
                const isNotBooked = event?.status === 'NotBooked'
                const icon = <ContactTaskSvg />
                const selected = selectedContact?.contact_data?.uniqueId === event?.uniqueId ? 'selected_card' : ''
                const status = getContactCurrentStatus(current_time, startTime, endTime, isNotBooked)
                const statusIcon = isNotBooked ? null : event_status_state[status]?.svg
                const uniqueid = `event-${index}-${startTime}-${endTime}-${groundStationName}`
                if (event?.status === 'Conflict') return null
                return (
                    <Event
                        key={uniqueid}
                        icon={icon}
                        statusIcon={statusIcon}
                        endTime={endTime}
                        eventName={groundStationName}
                        startTime={startTime}
                        allEvents={timelineContactData}
                        eventType={status}
                        className={selected}
                        overlay={ContactOverlay}
                        onClick={() => {
                            navigate_to('plan-ground-contact')
                            setSelectedContact({
                                selection_type: 'manual',
                                contact_type: status === 'ongoing' ? 'Ongoing' : status === 'upcoming' ? 'Upcoming' : 'Previous',
                                contact_data: event,
                            })
                        }}
                    />
                )
            })}
        </TimelineEventTrack>
    )
}

export default GroundContact